// extracted by mini-css-extract-plugin
export default {"customPopper":"VirtualizedAutocomplete_customPopper__Pbm8+"};